import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerForm from "./BannerForm";
import BannerText from "./BannerText";
import { LogoSlide } from "./LogoSlide";

const TopBanner = ({content}) => {
  return (
    <Container fluid className="top-banner">
      <Row>
        <Col md="12">
          <Container>
            <Row className="py-md-5">
              <Col md="7" sm="12" xs="12">
                <BannerText content={content} />
              </Col>
              <Col md="5" sm="12" xs="12" className="d-md-flex align-items-center">
                <BannerForm content={content.formData} />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <LogoSlide />
              </Col>
            </Row> */}
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default TopBanner;
